import { render, staticRenderFns } from "./page.vue?vue&type=template&id=e3f0deb4&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=e3f0deb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f0deb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3f0deb4')) {
      api.createRecord('e3f0deb4', component.options)
    } else {
      api.reload('e3f0deb4', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=e3f0deb4&scoped=true&", function () {
      api.rerender('e3f0deb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/blind/page.vue"
export default component.exports